import { FC, PropsWithChildren } from 'react';
import { Helmet } from 'react-helmet';

import { useAuth } from './auth/useAuth';

const SITE_NAME = 'Out of Dark';

const HelmetWrapper: FC<PropsWithChildren> = ({ children }) => {
	const auth = useAuth();
	const me = !auth.isLoading && auth.isSignedIn ? auth.me : null;

	const orgName =
		(Array.isArray(me?.person?.organizations) && me.person.organizations.find((organization) => organization.isCurrent === true)?.name) ||
		null;

	return (
		<>
			<Helmet
				titleTemplate={orgName ? `${orgName} - ${SITE_NAME} | $s` : `${SITE_NAME} | $s`}
				defaultTitle={orgName ? `${orgName} - ${SITE_NAME}` : SITE_NAME}
			/>
			{children}
		</>
	);
};

export { HelmetWrapper };
